export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  device: state => state.device,
  devices: state => state.devices,
  totalDevices: state => state.totalDevices,
  connectedDevices: state => state.connectedDevices,
  serverProfiles: state => state.serverProfiles,
  pairingInfo: state => state.pairingInfo,
  pairingInfoWorkOrder: state => state.pairingInfoWorkOrder,
  currentDevice: state => state.currentDevice
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/devices/getters.js